"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TABLE_LAYOUT_TITLE = exports.TABLE_LAYOUT_ROOT = exports.TABLE_LAYOUT_NAME = exports.TABLE_LAYOUT_DESCRIPTION = exports.CELL_MAX_LINES = void 0;
const TABLE_LAYOUT_ROOT = exports.TABLE_LAYOUT_ROOT = 'table-layout-root';
const TABLE_LAYOUT_TITLE = exports.TABLE_LAYOUT_TITLE = 'table-layout-title';
const TABLE_LAYOUT_DESCRIPTION = exports.TABLE_LAYOUT_DESCRIPTION = 'table-layout-description';
const TABLE_LAYOUT_NAME = exports.TABLE_LAYOUT_NAME = 'TableModule';
const CELL_MAX_LINES = exports.CELL_MAX_LINES = 4;
